import { Errors } from "services/forms/validation/types";

/**
 * Izvlači greške lokacije iz sheme koja je ugnijezdi pod ključ `location`.
 *
 * Yup ugniježđenim poljima daje putanju "location.officeId", a `VehicleLocationFields`
 * čita ravna imena ("officeId") — bez ovog prevođenja greške se ne bi prikazale ispod polja.
 * Tamo gdje se shema lokacije validira izravno (premještaj) putanje su već ravne, pa
 * i takve prolaze nepromijenjene.
 */
export const pickLocationErrors = (errors: Errors): Errors => {
  const prefix = "location.";
  const result: Errors = {};

  Object.entries(errors ?? {}).forEach(([key, message]) => {
    if (key.startsWith(prefix)) {
      result[key.slice(prefix.length)] = message;
      return;
    }

    // Greška na samom objektu lokacije — veže se uz izbor vrste.
    if (key === "location") {
      result.locationType = message;
      return;
    }

    result[key] = message;
  });

  return result;
};
